import { Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { ServiceSpecialistRecordContactTypeModalStore } from './service-specialist-record-contact-type-modal.store';
import { Validators } from '@angular/forms';
import { isInvalid } from '../../../../../shared/helpers/validate';
import {
    ServiceSpecialistRecordContactTypeUpdateInput,
} from '@libs/types/src/services/input-type/services/settings/service-specialist-record-contact-type.update-input';
import {
    ServiceSpecialistRecordContactTypeCreateInput,
} from '@libs/types/src/services/input-type/services/settings/service-specialist-record-contact-type.create-input';
import {
    ServiceSpecialistRecordContactTypeObject,
} from '@libs/types/src/services/object-type/service/settings/service-specialist-record-contact-type.object';
import { fb, routeParams } from '../../../../../shared/shared.global-service';
import { contentGlobalSuccess } from '../../../../content.error';
import { Dialog } from '@openng/optimus-ui/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { CheckInputComponent } from '../../../../../../components/kit/input/check-input/check-input.component';
import { TextInputComponent } from '../../../../../../components/kit/input/text-input/text-input.component';
import { ActionButtonsComponent } from '../../../../../../components/kit/action-buttons/action-buttons.component';

@Component({
    selector: 'app-service-specialist-record-contact-type-modal',
    templateUrl: 'service-specialist-record-contact-type-modal.component.html',
    styleUrl: 'service-specialist-record-contact-type-modal.component.scss',
    providers: [ServiceSpecialistRecordContactTypeModalStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        Dialog,
        TranslatePipe,
        CheckInputComponent,
        TextInputComponent,
        ActionButtonsComponent,
    ],
})
export class ServiceSpecialistRecordContactTypeModalComponent {
    protected readonly store = inject(ServiceSpecialistRecordContactTypeModalStore);


    @Input() item: ServiceSpecialistRecordContactTypeObject | null = null;

    protected visible = false;

    protected form = fb.group({
        active: fb.control<boolean>(true),
        name: fb.control<string>('', Validators.required),
        description: fb.control<string>(''),
    });

    public show(visible: boolean = true, item: ServiceSpecialistRecordContactTypeObject | null = null): void {
        this.visible = visible;
        this.item = item;
        if (item) {
            this.form.patchValue(item);
        }
    }

    protected async submit(): Promise<void> {
        if (isInvalid(this.form)) return;

        if (!this.item && routeParams.serviceId()) {
            const serviceId = Number(routeParams.serviceId());
            this.store.api.createServiceSpecialistRecordContactType({
                serviceId,
                ...this.form.value,
            } as ServiceSpecialistRecordContactTypeCreateInput)
                .then(() => contentGlobalSuccess.next('common.created'));
        } else if (this.item) {
            this.store.api.updateServiceSpecialistRecordContactType({
                id: this.item.id,
                ...this.form.value,
            } as ServiceSpecialistRecordContactTypeUpdateInput)
                .then(() => contentGlobalSuccess.next('common.updated'));
        }

        this.show(false);
    }

}
